import React, { Component } from 'react';
import {Link} from 'react-router'
import {Icone, Label} from 'react-template'

import "../../assets/css/components/formbuilder/formBox.css"

export class FormBoxConteiner extends Component {
    render() {
        return (
            <div className='row form-box-container'>
                {this.props.children}
                <FormBoxClear />
                <FormBoxClear />
                <FormBoxClear />
            </div>
        )
    }
}



export class GRUBox extends Component {

    getMaxTitulo(texto = ""){
        if(texto.length > 70){
            return texto.substring(0, 70) + "..."
        }

        return texto
    }

    render() {
        return (
            <Link to={this.props.url}>
                <div className='box form-box' title={`GRU ${this.props.titulo}`}>
                    <div>
                        <Icone icone='barcode' fontAwesome tamanho="5"/>
                    </div>
                    <div>
                        <section>
                            <b>{this.getMaxTitulo(this.props.titulo)}</b> <br />
                            <small>{this.props.descricao}</small>
                        </section>
                        <section className='form-box-footer'>
                            <section></section>
                        </section>
                    </div>
                </div>
            </Link>
        );
    }
}

export class FormBox extends Component {


    selectMonth(mes){
        switch (mes) {
            case '01':
                return 'Jan'
            case '02':
                return 'Fev'
            case '03':
                return 'Mar'
            case '04':
                return 'Abr'
            case '05':
                return 'Mai'
            case '06':
                return 'Jun'
            case '07':
                return 'Jul'
            case '08':
                return 'Ago'
            case '09':
                return 'Set'
            case '10':
                return 'Out'
            case '11':
                return 'Nov'
            case '12':
                return 'Dev'
            default:
                return 'Error'
        }
    }

    getMaxTitulo(texto = ""){
        if(texto.length > 70){
            return texto.substring(0, 70) + "..."
        }

        return texto
    }
 
    render() {
        // [dia, mes, titulo, permissao, valor, certificado, n_vagas onClick]
        return (
            <Link to={this.props.url}>
                <div className='box form-box' title={`Formulário ${this.props.titulo}`}>
                    <div>
                        <div>
                            <section>
                                {this.props.dia}
                            </section>
                            <section>
                                {this.selectMonth(this.props.mes)}
                            </section>
                        </div>
                    </div>
                    <div>
                        <section>
                            <b>{this.getMaxTitulo(this.props.titulo)}</b> <br />
                            <small>{this.props.permissao}</small>
                        </section>
                        <section className='form-box-footer'> 
                            {this.props.valor > 0  && (
                                <section>
                                    <Label basic color='green' title='Taxa de Inscrição' size=".85">
                                        valor: R$ {this.props.valor}
                                    </Label>
                                </section>
                            )}

                            {this.props.certificado && (
                                <section>
                                    <Label basic color='blue' title='Certificados' size=".85">
                                        <i className="fas fa-certificate" aria-hidden="true"></i> certificado
                                    </Label>
                                </section>
                            )}

                            {this.props.n_vagas > 0 && (
                                <section>
                                    <Label basic color='red' title='Certificados' size=".85">
                                        <i className="fas fa-certificate" aria-hidden="true"></i> vagas: {this.props.n_vagas}
                                    </Label>
                                </section>
                            )}
                            <section></section>
                        </section>
                    </div>
                </div>
            </Link>
        );
    }
}

export class FormBoxClear extends Component {
    render() {
        return (
            <a className='form-box-clear' tabIndex='-1'>
                <div className='box form-box'>
                </div>
            </a>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/formbuilder/FormBoxConteiner.js